import { useEffect, useState } from "react";
import { Printer } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { PRINT_PARTS, usePrintPart } from "./PrintPartsMenu";

// Nach dem Postversand: Auswahl, was gedruckt werden soll
export default function PostPrintDialog({ info, onClose }) {
  const { busy, run } = usePrintPart(info?.documentId);
  return (
    <Dialog open={!!info} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent className="max-w-md" data-testid="post-print-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Printer size={18} /> Für den Postversand drucken</DialogTitle>
          <DialogDescription>
            Das Schreiben{info?.attachmentCount ? ` und ${info.attachmentCount} Anlage${info.attachmentCount === 1 ? "" : "n"}` : ""} wurde gespeichert.
            {info?.signedOriginal ? " Das unterschriebene Original haben Sie bereits — drucken Sie ggf. nur die Anlagen." : ""}
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-2">
          {PRINT_PARTS.map((p) => (
            <Button key={p.part} variant={p.part === (info?.signedOriginal ? "attachments" : "all") ? "default" : "outline"}
              disabled={!!busy || (p.part !== "letter" && !info?.attachmentCount)}
              onClick={() => run(p.part)} className="justify-start gap-2" data-testid={`post-print-${p.part}`}>
              <Printer size={14} /> {busy === p.part ? "Bereite vor…" : p.label}
            </Button>
          ))}
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={onClose} data-testid="post-print-close">Schließen</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

const EVT = "domivus:post-print";
export const openPostPrint = (info) => window.dispatchEvent(new CustomEvent(EVT, { detail: info }));

// Global eingehängt (Layout), damit der Dialog auch nach dem Schließen des Editors bestehen bleibt
export function PostPrintHost() {
  const [info, setInfo] = useState(null);
  useEffect(() => {
    const h = (e) => setInfo(e.detail);
    window.addEventListener(EVT, h);
    return () => window.removeEventListener(EVT, h);
  }, []);
  return <PostPrintDialog info={info} onClose={() => setInfo(null)} />;
}
